export default "__VITE_ASSET__D7nH3C$0__"